<template>
  <DefaultLayout>
    <template #default>
      <slot/>
    </template>
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from "~/components/layout/DefaultLayout.vue";
</script>

